import React from "react";
import IconBase, { IconBaseProps } from "./IconBase";

const IconActionCard: React.FC<IconBaseProps> = ({
  size = 162,
  color = "#F6E7C4",
  className = "",
  ...props
}) => {
  const iconSize =
    typeof size === "number" ? size : parseInt(size as string, 10) || 162;
  return (
    <IconBase
      size={iconSize}
      color={color}
      className={className}
      viewBox="0 0 162 154"
      {...props}
    >
      <g opacity="0.6">
        <path
          d="M240.552 128.511L182.07 47.3939L180.531 45.2541C176.322 39.4183 167.622 39.3829 163.378 45.2187L161.839 47.3408L161.874 47.3762L134.694 84.9022L144.774 98.8904L171.954 61.3644L227.271 138.079C236.449 150.811 233.549 168.637 220.798 177.815L218.04 179.796C205.289 188.974 187.446 186.074 178.268 173.341L151.282 135.903L96.6727 60.1796L87.3884 47.2878L85.8676 45.1834C81.6411 39.3299 72.9227 39.3122 68.6962 45.1834L67.1754 47.2878L8.51675 128.264C-6.002 148.318 -1.51021 176.347 18.5791 190.866L21.3378 192.864C41.4094 207.383 69.4743 202.874 83.9931 182.82L114.428 140.802L104.348 126.814L70.7299 173.235C61.4987 185.968 43.6907 188.832 30.9404 179.619L28.1816 177.621C15.4313 168.407 12.5841 150.617 21.7976 137.884L77.2731 61.276L114.463 112.843L124.543 126.831L164.969 182.908C179.435 202.962 207.535 207.525 227.607 193.077L230.365 191.096C234.362 188.213 237.74 184.8 240.481 181.034C251.516 165.808 252.135 144.586 240.552 128.529V128.511Z"
          fill={color}
        />
        <path
          d="M124.508 52.0624C138.884 52.0624 150.539 40.4078 150.539 26.0312C150.539 11.6546 138.884 0 124.508 0C110.131 0 98.4766 11.6546 98.4766 26.0312C98.4766 40.4078 110.131 52.0624 124.508 52.0624Z"
          fill={color}
        />
      </g>
    </IconBase>
  );
};

export default IconActionCard;
